import moment from 'moment'
import { compose, includes, partial, propOr } from 'ramda'
import React from 'react'
import debug from 'debug'

const authDebug = debug('linkgua:auth:checks')

const propOrNull = propOr(null)

const accessToken = (authUser) => propOrNull('accessToken', authUser)

const accessTokenPayload = (authUser) => {
  const rawJwtAccessToken = accessToken(authUser)

  if (!rawJwtAccessToken) {
    return null
  }

  const rawJwtAccessTokenParts = rawJwtAccessToken.split('.')
  if (rawJwtAccessTokenParts.length !== 3) {
    authDebug('invalid raw jwt access token: %s', rawJwtAccessToken)
  }

  return JSON.parse(atob(rawJwtAccessTokenParts[1]))
}

export const tokenNearExpiry = (graceSeconds, authUser) => {
  const accessTokenJwtPayload = accessTokenPayload(authUser)
  if (accessTokenJwtPayload == null) {
    authDebug('accessTokenJwtPayload %O', accessTokenJwtPayload)
    return true
  }

  const expMoment = moment.unix(accessTokenJwtPayload.exp)
  const expGraceMoment = moment.unix(moment().unix() + graceSeconds)
  const expired = expMoment.isBefore(expGraceMoment)

  authDebug('tokenNearExpiry check: grace seconds %d, unix now %s, exp mom %s, expGrace %s', graceSeconds, moment().unix(), expMoment.toISOString(), expGraceMoment.toISOString())

  if (expired) {
    authDebug('token expired when using grace period of %d seconds: %s < %s', graceSeconds, expMoment.toISOString(), expGraceMoment.toISOString())
  }
  return expired
}

export const tokenExpired = partial(tokenNearExpiry, [0])

export const checkAuthentication = (authUser) => accessToken(authUser) && !tokenExpired(authUser)

export const linkguaProfile = (user) => propOrNull('profile', user)

export const getLinkguaType = (user) => compose(
  propOrNull('type'),
  linkguaProfile
)(user)

export const isSignUpComplete = (user) => {
  if(!user) return false

  const profile = linkguaProfile(user)

  authDebug('%O', profile)
  return checkAuthentication(user.authUser) &&
    profile && (
      profile.type === 'customer' ||
      profile.type === 'specialist' && includes(profile.profileStatus, ['onboarded', 'active'])
    )
}



// WEBPACK FOOTER //
// ./util/checkAuthentication.js